import {UserManager} from 'oidc-client-ts';
import {env_vars} from './utilities/load-env';

export let idPortenUserManager;
export const configureIdPortenUserManager = () => {
    idPortenUserManager = new UserManager({
        client_id: env_vars.OIDC_CLIENT_ID,
        redirect_uri: env_vars.OIDC_REDIRECT_URI,
        post_logout_redirect_uri: env_vars.OIDC_POST_LOGOUT_REDIRECT_URI,
        scope: 'openid profile',
        response_type: 'code',
        ui_locales: 'nb',
        acr_values: env_vars.OIDC_ACR_VALUES,
        authority: env_vars.OIDC_AUTHORITY,
        automaticSilentRenew: true,
        includeIdTokenInSilentRenew: true
    });

    idPortenUserManager.events.addUserSignedOut(() => {
        idPortenUserManager.signoutRedirect();
    });

    idPortenUserManager.events.addSilentRenewError(() => {
        idPortenUserManager.signoutRedirect();
    });
};

